var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interests"},[_c('dConnectToggle',{attrs:{"interests":_vm.value}}),_c('interests-search',{attrs:{"interests":_vm.value},on:{"input":function($event){return _vm.input.apply(void 0, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }